import React from 'react';
import { Card } from "react-bootstrap";


const Hero_Section_Contact = (props) => {


    return (
        <>
            <Card className="bg-dark text-white no-radius">
                <Card.Img src={props.valHero.hero_img.data[0].attributes.formats.large.url} style={{ height: '25rem', width: '100%', objectFit: 'cover' }} />
                <Card.ImgOverlay>
                    <div className="hero-center">
                        <h4 className="text-center sub-hero-h">{props.valHero.hero_imgTextOne}</h4>
                        <p className="py-2 text-center sub-hero-p">{props.valHero.hero_imgTextTwo}</p>
                    </div>
                </Card.ImgOverlay>
            </Card>
        </>
    );
};

export default Hero_Section_Contact